/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LastLoggedInUserMode } from './lastLoggedInUserMode';
import { GroupType } from './groupType';


export interface WlaSettingModel { 
    id?: number;
    isActive?: boolean;
    organizationID?: number;
    domain: string;
    applySubdomains?: boolean;
    groupID?: number | null;
    groupType?: GroupType;
    groupName?: string | null;
    lastLoggedInUserMode?: LastLoggedInUserMode;
    emergencyUser01?: string | null;
    emergencyUserPassword01?: string | null;
    emergencyUser02?: string | null;
    emergencyUserPassword02?: string | null;
    enforceMFA?: boolean;
    enableConsole?: boolean;
    enableRDP?: boolean;
    protectLogon?: boolean;
    protectUnlock?: boolean;
    createdBy?: string | null;
    modifiedBy?: string | null;
    createdDate?: string;
    modifiedDate?: string;
}

